import {ExtensionType} from './Extension';
import {ServiceFeatureName} from './ServiceFeature';
import {YesNo} from "./CallScreening";
import {APIErrorInterface} from './errors';
import {isMaxOfferedQuantityFault} from './faults';

export enum CreateAccountFaultCode {
    MaxOfferedQuantity = 'Server.Customer.Maximum offered quantity exceeded',
    MaxQuantityErrorPartial = 'Server.Account.Maximum offered quantity exceeded for product ID',
    DuplicateId = 'Server.Account.The ID {account_id} cannot be used because an account with the same id already exists',
    ServerAccountDuplicateId = 'Server.Account.duplicate_id',
    ForbiddenCharacterId = 'Client.Account.account_info.id.forbidden_character',
}

export enum CreateAccountFaultString {
    DuplicateId = 'duplicate_id',
}

export enum AccountIdFaultKind {
    DuplicateId,
    ForbiddenCharacter,
    LimitExceeded,
    Unknown,
}

export function getAccountFaultKind(error?: APIErrorInterface | null): AccountIdFaultKind {
    const faultcode = error?.faultcode ?? '';
    const faultstring = error?.faultstring ?? '';

    if (
        faultcode === CreateAccountFaultCode.ServerAccountDuplicateId ||
        faultstring === CreateAccountFaultString.DuplicateId ||
        faultstring.toLowerCase().includes('duplicate') ||
        (faultcode.includes('The ID') && faultcode.includes('account with the same id already exists'))
    ) {
        return AccountIdFaultKind.DuplicateId;
    }

    if (faultcode === CreateAccountFaultCode.ForbiddenCharacterId) {
        return AccountIdFaultKind.ForbiddenCharacter;
    }

    if (isMaxOfferedQuantityFault(faultcode)) {
        return AccountIdFaultKind.LimitExceeded;
    }

    return AccountIdFaultKind.Unknown;
}

export interface AccountRoleInfo {
    i_account_role?: number;
    inventory_usage?: string;
    name?: string;
    realm?: string | null;
    validation_format?: string | null;
}

export interface AccountListRequest {
    i_customer: number|string;
    account_role_list?: AccountRoleInfo[];
    free_of_extensions?: number;
    extension_id: string;
    get_only_real_accounts: number | null;
    email: string;
    blocked: string;
    extension_name: string;
    id: string;
    did_number:string
    sip_status: string;
    limit: number;
    offset: number;
    get_statuses: number;
    expand_alias: number;
    get_total: number;
    get_not_closed_accounts: number;
    has_extension?: number;
    get_service_features?: ServiceFeatureName[];
    service_features_filter?: ServiceFeaturesFilter[],
    useNewLogic?:boolean,
    with_call_processing_mode?: number;
}

interface ServiceFeaturesFilter {
    effective_flag_value: YesNo,
    name: string
}

export interface AccountListResponse {
    account_list: ExtensionType[];
    total: number;
}
